
import TitleBox from '@/components/CSS/TitleBox'
import { mapGetters } from 'vuex'

export default {
    components: {
        TitleBox
    },
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo'
        })
    }
}
